/* eslint-disable react/no-access-state-in-setstate,no-shadow, no-unused-vars */
import React, { Component } from 'react';

const GeneralTableRow = props => (
  <div className="requests-row">
    <div className="row">
      <div className="col-md-first" />
      <div className="col-md-2">
        <span>
          {props.employmentId}
        </span>
      </div>
      <div className="col-md-2">
        <span>
          {props.employeeName}
        </span>
      </div>
      <div className="col-md-2">
        <span>
          {props.travelExpenseGroup}
        </span>
      </div>
      <div className="col-md-2">
        <span>
          {props.calculatedAmount.domestic}
          {' '}
TL
        </span>
      </div>
      <div className="col-md-2 ellipsis">
        <span>
          {props.calculatedAmount.abroad}
          {' '}
TL
        </span>
      </div>
      <div className="col-md-last">
        <span>
          {props.uploaded === 0 ? 'Aktarılmadı' : 'Aktarıldı'}
        </span>
      </div>
    </div>
  </div>
);


export default GeneralTableRow;



// WEBPACK FOOTER //
// ./src/components/reports/GeneralTableRow.js